import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Spinner } from './core/shared/components/spinner/spinner';
import { CommonModule } from '@angular/common';
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular';

import { PickListService } from './core/shared/services/picklist.service';
import { AdminService } from './components/setup/shared/service/admin.service';
import { NotificationSocketService } from './core/shared/services/notification-socket.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Spinner, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  constructor(
    private keycloak: KeycloakService,
    private pickListService: PickListService,
    private adminService: AdminService,
      private notificationSocket: NotificationSocketService   
  ) {}

async ngOnInit() {
  this.pickListService.loadGlobalLists();
  this.adminService.loadUserPermissions();

  this.keycloak.keycloakEvents$.subscribe(async (event) => {
    if (event.type === KeycloakEventTypeLegacy.OnAuthRefreshSuccess) {
      const refreshedToken = await this.keycloak.getToken();
      localStorage.setItem('auth_token', refreshedToken);

      // ✅ Token refresh hone ke baad socket reconnect karo
      this.notificationSocket.disconnect();
      await this.notificationSocket.connect();
    }

    // ✅ Pehli baar login ke baad connect karo
    if (event.type === KeycloakEventTypeLegacy.OnAuthSuccess) {
      await this.notificationSocket.connect();
    }
  });
}
  protected readonly title = signal('Lonaly');
}
